import { SET_CONFIGS } from 'commons-configs/actions/ConfigsActionType.js';
import ConfigsModel from 'commons-configs/models/ConfigsModel.js';

export default function configReducer(state = new ConfigsModel(), action) {
    if (action.type === SET_CONFIGS) {
        return new ConfigsModel(action.configs);
    }
    return state;
}
